<template>
  <div class="daily-concepts-figures">
    <v-row>
      <v-col v-for="[key, value] of Object.entries(countryDiff)" :key="key" cols="12" sm="6" md="2">
        <v-card>
          <v-card-title class="d-flex justify-center caption">
            <span>{{getElementByUuid(key, concepts).label}}</span>
          </v-card-title>
          <v-card-text>
            <v-row class="d-flex justify-center">
              <v-avatar size="50px" tile>
                <v-img :src="getElementByUuid(key, concepts).logo" contain class />
              </v-avatar>
            </v-row>
            <v-row class="d-flex justify-center">
              <span class="title">{{value.current}}</span>
              <v-icon :color="value.diff.color" small class="mx-2">{{value.diff.icon}}</v-icon>
              <span
                :class="value.diff.color + '--text text-caption d-flex align-center'"
              >({{value.diff.label}})</span>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  props: {
    orders: { type: Array },
    lastWeekOrders: { type: Array },
    concepts: { type: Array },
  },
  computed: {
    countryDiff() {
      let res = {};
      for (let [key, value] of Object.entries(this.ordersByConcept)) {
        if (!(key in res)) {
          res[key] = {};
        }
        res[key]["current"] = value.length;
        res[key]["lastWeek"] = 0;
      }
      for (let [key, value] of Object.entries(this.lastWeekOrdersByConcept)) {
        if (!(key in res)) {
          res[key] = {};
        }
        res[key]["lastWeek"] = value.length;
        if (!("current" in res[key])) {
          res[key]["current"] = 0;
        }
      }
      for (let value of Object.values(res)) {
        let diff = null;
        if (value.lastWeek) {
          diff = Math.round(
            ((value.current - value.lastWeek) / value.lastWeek) * 100
          );
        }
        value["diff"] = this.getDiffStyle(diff);
      }
      return res;
    },
    ordersByConcept() {
      return _.chain(this.orders).groupBy("concept_uuid").value();
    },
    lastWeekOrdersByConcept() {
      return _.chain(this.lastWeekOrders).groupBy("concept_uuid").value();
    },
  },
  methods: {
    getElementByUuid(uuid, list) {
      let found = list.find((element) => element.uuid == uuid);
      return found
        ? { label: found.label, logo: found.logo }
        : { label: "unknown", logo: "unknown" };
    },
    getDiffStyle(diff) {
      let label = "-";
      let icon = "mdi-dots-horizontal";
      let color = "grey";
      if (diff < 0) {
        icon = "mdi-arrow-down-bold-circle";
        color = "error";
        label = diff + "%";
      } else if (diff > 0) {
        icon = "mdi-arrow-up-bold-circle";
        color = "success";
        label = "+" + diff + "%";
      } else {
        icon = "mdi-arrow-right-bold-circle";
        color = "warning";
        label = diff + "%";
      }
      return {
        label: label,
        icon: icon,
        color: color,
      };
    },
  },
};
</script>
